module.exports = __webpack_public_path__ + "static/media/1.3.4-dashboard-news.05dfd7e1.jpg";